<div id="print-section"
     style="width:100%; font-family:Arial, sans-serif; font-size:12px; border:1px solid black;">

  <!-- ===== HEADER ===== -->
  <table style="width:100%; border-collapse:collapse; border-bottom:1px solid black; background-color:#f8f9fa;">
    <tr>
      <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;">
        हिंदुस्तान प्रकाशन संस्था
      </td>
      <td style="font-size:18px; font-weight:bold; text-align:center;">
        Granth Business Report
      </td>
      <td style="font-size:18px; text-align:right; padding:8px; font-weight:bold;">
        दिनांक : {{ today | date:'dd-MM-yyyy' }}
      </td>
    </tr>
    <tr style="border-top:1px solid black;">
      <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;">
        विवेक पुस्तक प्रकाशन
      </td>
      <td style="font-size:18px; font-weight:bold; text-align:center;">
        In Detail
      </td>
      <td style="font-size:18px; text-align:right; padding:8px; font-weight:bold;">
        From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
      </td>
    </tr>
  </table>

  <!-- ===== DATA TABLE ===== -->
  <div style="width:100%; overflow:auto;">
    <table style="width:100%; border-collapse:collapse; border:1px solid black; table-layout:fixed;">
      <thead>
        <tr style="background-color:#f1f1f1; text-align:center;">
          <th style="border:1px solid black; padding:6px; width:50px;">अ.क्र.</th>
          <th style="border:1px solid black; padding:6px; width:180px;">प्रतिनिधीचे नाव</th>
          <th style="border:1px solid black; padding:6px; width:100px;">जिल्हा</th>
          <th style="border:1px solid black; padding:6px; width:120px;">तालुका</th>
          <th *ngFor="let month of months" style="border:1px solid black; padding:6px; width:70px;">
            {{ month }}
          </th>
          <th style="border:1px solid black; padding:6px; width:70px;">एकुण</th>
          <th style="border:1px solid black; padding:6px; width:90px;">उद्दीष्ठ</th>
          <th style="border:1px solid black; padding:6px; width:70px;">फरक</th>
          <th style="border:1px solid black; padding:6px; width:120px;">टिप</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let group of reportData; let gIndex = index">

          <!-- ===== GROUP HEADER ===== -->
          <tr style="background:#b0c4cf; font-weight:bold; text-align:center;">
            <td [attr.colspan]="4 + months.length"
                style="border:1px solid black; padding:6px; text-align:left;">
              <b>कार्यालय प्रतिनिधी - </b>{{ group.groupName }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{ group.totalAmount }}
            </td>
            <td style="border:1px solid black; padding:4px;">
              <input type="number"
                     [(ngModel)]="group.uddisht"
                     (ngModelChange)="calculateGroupFarak(group)"
                     style="width:70px; text-align:right; border:1px solid #999;
                            border-radius:3px; padding:2px;" />
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;"
                [style.color]="getGroupFarakDisplay(group) < 0 ? 'red' :
                               (getGroupFarakDisplay(group) > 0 ? 'green' : 'black')">
              {{ getGroupFarakDisplay(group) }}
            </td>
            <td style="border:1px solid black; padding:4px;">
              <input type="text"
                     [(ngModel)]="group.tip"
                     (ngModelChange)="saveToLocalStorage()"
                     placeholder="टिप..."
                     style="width:100px; border:1px solid #999;
                            border-radius:3px; padding:2px 4px;" />
            </td>
          </tr>

          <!-- ===== DATA ROWS ===== -->
          <tr *ngFor="let row of group.rows; let i = index; trackBy: trackByIndex" style="text-align:center;">
            <td style="border:1px solid black; padding:6px;">{{ i + 1 }}</td>
            <td style="border:1px solid black; padding:6px; text-align:left;">{{ row.name }}</td>
            <td style="border:1px solid black; padding:6px;">{{ row.district }}</td>
            <td style="border:1px solid black; padding:6px;">{{ row.taluka }}</td>

            <td *ngFor="let m of months" style="border:1px solid black; padding:6px; text-align:right;">
              {{ row[m] || 0 }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{ row.totalAmount }}
            </td>

            <td style="border:1px solid black; padding:4px;">
              <input type="number"
                     [(ngModel)]="row.colValue"
                     (ngModelChange)="calculateRowFarak(row)"
                     min="0"
                     style="width:70px; text-align:right; border:1px solid #999;
                            border-radius:3px; padding:2px;" />
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;"
                [style.color]="getRowFarak(row) < 0 ? 'red' :
                               (getRowFarak(row) > 0 ? 'green' : 'black')">
              {{ getRowFarak(row) }}
            </td>

            <td style="border:1px solid black; padding:4px;">
              <input type="text"
                     [(ngModel)]="row.tip"
                     (ngModelChange)="saveToLocalStorage()"
                     placeholder="टिप..."
                     style="width:100px; border:1px solid #999;
                            border-radius:3px; padding:2px 4px;" />
            </td>
          </tr>

          <!-- ===== GROUP TOTAL ROW ===== -->
          <tr style="background-color:#f4b084; font-weight:bold;">
            <td colspan="4" style="border:1px solid black; padding:6px; text-align:right;">
              एकूण Total
            </td>
            <td *ngFor="let m of months" style="border:1px solid black; padding:6px; text-align:right;">
              {{ getGroupMonthTotal(group, m) }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{ getGroupTotalAmount(group) }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{ getGroupUddisht(group) }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;"
                [style.color]="getGroupRowFarak(group) < 0 ? 'red' : (getGroupRowFarak(group) > 0 ? 'green' : 'black')">
              {{ getGroupRowFarak(group) }}
            </td>
            <td style="border:1px solid black;"></td>
          </tr>

        </ng-container>
      </tbody>

      <!-- ===== GRAND TOTAL ===== -->
     
        <tr style="background-color:#c8753f; color:#fff; font-weight:bold;">
          <td colspan="4" style="border:1px solid black; padding:6px; text-align:right;">
            Grand Total
          </td>
          <td *ngFor="let m of months" style="border:1px solid black; padding:6px; text-align:right;">
            {{ getGrandMonthTotal(m) }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right;">
            {{ grandTotalAmount }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right;">
            {{ grandTotalUddisht }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;"
              [style.color]="grandTotalFarak < 0 ? 'red' : (grandTotalFarak > 0 ? 'green' : 'black')">
            {{ grandTotalFarak }}
          </td>
          <td style="border:1px solid black;"></td>
        </tr>
    
    </table>
  </div>

  <!-- ===== BUTTONS ===== -->
  <div class="button-container noPrint" style="margin-top:20px; text-align:center;">
    <button mat-button mat-dialog-close>❌ Close</button>
    <button mat-raised-button color="primary" (click)="exportExcel('OfficeRep_Report')">
      📊 Export
    </button>

    <button mat-raised-button color="accent" (click)=" printReportA3()">
      🖨️ Print
    </button>
  </div>
</div>